module.exports = {
    props: ['user', 'teamId'],


    /**
     * Load mixins for the component.
     */
    mixins: [require('./../../mixins/tab-state')],


    /**
     * The component's data.
     */
    data() {
        return {
            billableType: 'team',
            team: null,
            activeTab: 'Team Profile'
        };
    },


    /**
     * The component has been created by Vue.
     */
    created() {
        var self = this;

        this.getTeam();

        Bus.$on('updateTeam', function () {
            self.getTeam();
        });
    },


    /**
     * Prepare the component.
     */
    mounted() {
        this.usePushStateForTabs('.spark-settings-tabs');
    },


    methods: {
        /**
         * Get the team being managed.
         */
        getTeam() {
            axios.get(`/settings/${Spark.teamsPrefix}/json/${this.teamId}`)
                .then(response => {
                    this.team = response.data;
                });
        },
        
        changeTab(tabId) {
            // Remove 'active' class from all tabs
            const tabs = document.querySelectorAll('.tab-pane');
            tabs.forEach((tab) => tab.classList.remove('active'));
    
            // Find the selected tab and add 'active' class
            const selectedTab = document.querySelector(tabId);
            if (selectedTab) {
                selectedTab.classList.add('active');

                // Get tab name from the clicked element and update activeTab
                const tabName = document.querySelector(`[href="${tabId}"]`)?.textContent.trim();
                if (tabName) {
                    this.activeTab = tabName;
                }
            } else {
                console.warn(`Tab with ID "${tabId}" not found.`);
            }
        },
    }
};
